import script from "./commonOutWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./commonOutWarehouse.vue?vue&type=script&setup=true&lang=js"

import "./commonOutWarehouse.vue?vue&type=style&index=0&id=52afd4f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52afd4f8"]])

export default __exports__